import { Box } from '@mui/material'
import LanguageDropdown from 'src/@core/layouts/components/shared-components/LanguageDropdown'
import { useSettings } from 'src/@core/hooks/useSettings'

/** Fixed EN/FR toggle for guest auth flows (login, registration, forgot password, etc.) */
const AuthLanguageBar = () => {
  const { settings, saveSettings } = useSettings()

  return (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: 12, md: 20 },
        right: { xs: 12, md: 24 },
        zIndex: theme => theme.zIndex.tooltip
      }}
    >
      <LanguageDropdown settings={settings} saveSettings={saveSettings} />
    </Box>
  )
}

export default AuthLanguageBar
